import useApplicationManagerProject from 'Hooks/queries/useApplicationManagerProject';
import { useProject as useCreatorbaseProject } from '@round/creatorbase-helpers/api-hooks';
import { CREATORBASE_ROOT_PATH } from 'Modules/Navigation/whitelabel/routes';
import { useCheckUserGroupsAccess } from 'Modules/Auth/hooks/useCheckUserGroupsAccess';
import { useCurrentCreatorbaseUser } from 'Modules/Auth/hooks/useCurrentCreatorbaseUser';
import { useQuery } from '@tanstack/react-query';
import { creatorbaseQueries } from '@round/api';

export default function useCreatorbaseProjectNavigationLink(appManagerProjectId: number | null | undefined) {
    const isUserAdmin = useCheckUserGroupsAccess(['user_admin'], 'all');
    const { hasAccess: hasCreatorbaseAccess } = useCurrentCreatorbaseUser();
    const canNavigateToCreatorbaseProject = Boolean(hasCreatorbaseAccess && isUserAdmin);

    const { data: appManagerProject } = useApplicationManagerProject(appManagerProjectId, {
        enabled: canNavigateToCreatorbaseProject,
        refetchOnWindowFocus: false,
    });

    const { data: creatorbaseProject } = useCreatorbaseProject(appManagerProject?.creatorbase_project_id, {
        enabled: typeof appManagerProject?.creatorbase_project_id === 'number',
    });

    const { data: team } = useQuery({
        ...creatorbaseQueries.team.options.detail(creatorbaseProject?.team_id),
        enabled: !!creatorbaseProject?.team_id,
    });

    const { data: brand } = useQuery({
        ...creatorbaseQueries.brand.options.detail(creatorbaseProject?.brand_id),
        enabled: !!creatorbaseProject?.brand_id,
    });

    return {
        creatorbaseProjectUrl:
            creatorbaseProject && canNavigateToCreatorbaseProject
                ? `/${CREATORBASE_ROOT_PATH}/projects/${creatorbaseProject.id}/`
                : null,
        creatorbaseProject,
        creatorbaseTeam: team,
        creatorbaseBrand: brand,
    };
}
